import styled from 'styled-components';

interface SubPageSelectButtonContainerProps {
    color?: string;
    backgroundColor?: string;
    transitionDuration?: number;
}

export const SubPageSelectButtonContainer = styled.div<SubPageSelectButtonContainerProps>`
    padding: 10px;
    border-radius: 20px;

    ${props => props.color ? `color: ${props.color};` : ''}
    ${props => props.backgroundColor ? `background-color: ${props.backgroundColor};` : ''}

    ${props => props.transitionDuration ? `transition: ${props.transitionDuration}ms;` : ''}

    cursor: pointer;
    user-select: none;
`;
